export const ADD_EMAIL = "ADD_EMAIL";
export const addEmail = (data) => {
    // console.log(data)
    return {
        type: ADD_EMAIL,
        payload:data
    }
}